module.exports = __webpack_public_path__ + "static/media/stephen.a7b2055d.jpg";